module.exports = __webpack_public_path__ + "static/gallery2-1a5a14063ff59313c04ea45e9cebea8b.jpg";